import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { SnackService } from '../../services/snack.service';
import { SubscriptionBasedComponent } from '../../subscription-helpers/subscription-based.component';
import { filter } from 'rxjs/operators';
import UserHelper from '../../helpers/user-helper';
import * as globals from '../../../globals/globals';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
})
export class ResetPasswordComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  resetPasswordForm: any;
  message: string;
  public render = false;

  constructor(
    private fb: UntypedFormBuilder,
    private authService: AuthService,
    private snackService: SnackService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    super();
    this.resetPasswordForm = this.fb.group({
      password: ['', [Validators.required]],
      repeatPassword: ['', [Validators.required]],
      persist: [false, []],
    });
  }

  ngOnInit() {
    this.addSubscription(
      this.authService.authWithTokenEvent,
      (success: boolean) => {
        if (!success) {
          this.router.navigateByUrl('login');
        } else {
          this.render = true;
        }
      }
    );

    this.route.queryParams
      .pipe(filter((params) => params.token))
      .subscribe((params) => {
        this.authService.authenticateWithToken(params.token);
      });
  }

  resetPassword() {
    if (
      this.resetPasswordForm.value.password !==
      this.resetPasswordForm.value.repeatPassword
    ) {
      this.snackService.showError('De wachtwoorden komen niet overeen');
    } else {
      this.authService.resetPassword(this.resetPasswordForm.value.password);
      this.addSubscription(
        this.authService.resetPasswordEvent,
        (success: boolean) => {
          if (!success) {
            this.snackService.showError(
              'Kon wachtwoord niet resetten, probeer later opnieuw'
            );
          } else {
            this.snackService.showSuccess('Wachtwoord succesvol gereset');
            const user = this.authService.getAuthenticatedUser();
            if (UserHelper.isClient(user)) {
              if (user.hasNewPortalAccess) {
                window.location.href = globals.newPortalUrl;
              } else {
                this.router.navigateByUrl('/client-corner/lopende');
              }
            } else if (UserHelper.isPlacer(user)) {
              this.router.navigateByUrl('/installateur');
            } else {
              this.router.navigateByUrl('/projecten');
            }
          }
        }
      );
    }
  }
}
